import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Legge l'interruttore shop_settings.orders_enabled. Finché la risposta non
 * arriva, o se la lettura fallisce, gli ordini risultano chiusi: meglio
 * bloccare un checkout in più che lasciarne passare uno. Il blocco vero è
 * comunque lato server (RLS su orders e create-checkout-session).
 */
export function useOrdersEnabled() {
  const [ordersEnabled, setOrdersEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const { data, error } = await supabase
      .from('shop_settings')
      .select('orders_enabled')
      .maybeSingle();
    if (error) console.error('Error reading shop settings:', error);
    setOrdersEnabled(!error && !!data?.orders_enabled);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  /** Solo admin con 2FA: la RLS rifiuta l'update a chiunque altro. */
  const setOrdersEnabledRemote = async (enabled: boolean) => {
    const { data, error } = await supabase
      .from('shop_settings')
      .update({ orders_enabled: enabled, updated_at: new Date().toISOString() })
      .eq('id', true)
      .select('orders_enabled');
    if (error) throw new Error(error.message);
    // Con RLS un update non autorizzato non dà errore: semplicemente non
    // tocca nessuna riga.
    if (!data || data.length === 0) throw new Error('Non autorizzato a modificare le impostazioni');
    setOrdersEnabled(!!data[0].orders_enabled);
  };

  return { ordersEnabled, loading, refresh, setOrdersEnabled: setOrdersEnabledRemote };
}
